import { useState } from 'react';
import { faqs } from '@/mocks/site';
import JsonLd from '@/components/feature/JsonLd';

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a,
      },
    })),
  };

  return (
    <section id="faq" className="w-full scroll-mt-24 bg-background-100 px-4 py-12 md:px-8 md:py-16">
      <JsonLd data={faqSchema} />
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-[0.8fr_1.2fr]">
        <div>
          <span className="text-sm font-bold text-primary-600">常见问题</span>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">
            你可能想先搞清楚的事
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            关于更新频率、内容类型、投稿方式和转载规则，这里一次说清楚。如果还有疑问，欢迎到"关于我们"页面留言。
          </p>
          <div className="mt-6 flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-2xl text-accent-700">
              <i className="ri-customer-service-2-line" aria-hidden="true"></i>
            </span>
            <p className="text-sm text-foreground-700">
              没找到答案？直接在关于我们页面留下你的问题。
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((item, idx) => {
            const isOpen = open === idx;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : idx)}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="text-sm font-bold text-foreground-950 md:text-base">{item.q}</span>
                  <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${isOpen ? 'bg-primary-500 text-background-50 dark:text-foreground-950' : 'bg-background-100 text-foreground-600'}`}>
                    <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} aria-hidden="true"></i>
                  </span>
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}